// extracted by mini-css-extract-plugin
module.exports = {"cardTitle":"CardTitle_cardTitle__1KEwi"};